
export function ingenieriaError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.isOK = false
}

export function setIsOk(state,payload){
    state.isOk = payload
}
export function setOrdenes(state,payload){
    state.ordenes = payload.ordenes.data
}

export function setHistorico(state,payload){
    state.historico = payload.data.historico
}